import React, { FC, useEffect, useState } from "react";
import { t } from "i18next";
import { ApplicationFeature } from "@green0meter/api-client";

import Tabs, { tabs } from "./components/Tabs";

import { PbiReport } from "@components/common";
import { Box, Card, CardContent, Stack, Typography } from "@components/base";
import { getWindowSize } from "@helpers";
import { REPORT_PAGES } from "@constants";

interface Co2Overview {
  version?: "co2" | "esrs";
}

const Co2Overview: FC<Co2Overview> = ({ version = "co2" }) => {
  const [activeTab, setActiveTab] = useState<Tabs["activeTab"]>("overview");
  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    const handleWindowResize = (): void => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          pb={3}
        >
          <Typography variant="subtitle1">
            {t("co2.hub.dashboard.overview")}
          </Typography>
        </Stack>
        <Stack spacing={3}>
          <Tabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            version={version}
          />
          <Box
            sx={{
              height: windowSize.innerWidth * 0.43,
              overflow: "hidden",
            }}
          >
            <PbiReport
              bg={"default"}
              pageId={
                tabs.find((t) => t.path === activeTab)?.pageId || REPORT_PAGES.CO2
              }
              reportId={tabs.find((t) => t.path === activeTab)?.reportId}
              height={windowSize.innerWidth * 0.5}
              extraFilters={[]}
              reportType={ApplicationFeature.CO2}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default Co2Overview;
